import { ChangeDetectionStrategy, Component, inject, model } from '@angular/core';

import { ReactiveFormsModule, FormBuilder } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { EditorModule } from 'primeng/editor';
import { LoggerService } from '@/core/services/logger.service';

import { DialogoPadraoDirective } from '@/shared/components/layout/dialogo-padrao/dialogo-padrao.directive';
// Interfaces para tipagem
interface TeamMember {
    id: number;
    name: string;
    avatar: string;
}

/** Diálogo de inserção de tarefa (mock) do módulo de Orientações Técnicas. */
@Component({
    selector: 'app-inserir-tarefa-orientacoes',
    standalone: true,
    imports: [DialogoPadraoDirective, ReactiveFormsModule, DialogModule, EditorModule],
    templateUrl: './inserir-tarefa-orientacoes.component.html',
    styleUrls: ['./inserir-tarefa-orientacoes.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InserirTarefaOrientacoesComponent {
    private readonly fb = inject(FormBuilder);
    private readonly logger = inject(LoggerService);

    /** Visibilidade do diálogo (two-way com o pai). */
    readonly visible = model<boolean>(false);

    members: TeamMember[] = [
        {
            id: 1,
            name: 'César',
            avatar: 'images/logos/logo.png'
        },
        {
            id: 2,
            name: 'Peterson',
            avatar: 'images/logos/logo.png'
        }
    ];

    readonly taskForm = this.fb.group({
        taskName: [''],
        description: [''],
        startDate: [''],
        dueDate: [''],
        members: [this.members]
    });

    onVisibleChange(visible: boolean) {
        this.visible.set(visible);
    }

    removeMember(id: number) {
        this.members = this.members.filter((m) => m.id !== id);
        this.taskForm.patchValue({ members: this.members });
    }

    saveTask() {
        if (this.taskForm.valid) {
            this.logger.info('Tarefa salva', this.taskForm.value);
        }
    }

    onCancel() {
        this.logger.info('Inserção de tarefa cancelada');
        if (this.visible()) {
            this.visible.set(false);
        }
    }
}
